import React from 'react';
import {useTranslation} from 'react-i18next';
import List from '../../../../../../component/list/List';
import OptionalIcon from '../../../../../../assets/icons/OptionalIcon';
import MandatoryIcon from '../../../../../../assets/icons/MandatoryIcon';
import useShow from '../../../../../../hooks/useShow';
import {getEventKindOptions, getEventKindText} from '../../utils/utils';
import {EventKind, EventHandler} from '../../utils/types';
import * as css from './EventKindDropdown.css';

interface EventKindDropdownProps {
    eventId: number;
    eventKind: EventKind | null;
    isSelected: boolean;
    handleEvent: EventHandler;
    disabled?: boolean;
}

export default function EventKindDropdown({eventId, eventKind, isSelected, handleEvent, disabled = false}: EventKindDropdownProps) {
    const {t} = useTranslation('subscriptions');
    const dropdownStates = useShow(300);
    
    const eventKindOptions = getEventKindOptions(eventId, handleEvent, t, dropdownStates.close);

    const handleToggle = () => {
        if(disabled) return;
        if(dropdownStates.isOpen) {
            dropdownStates.close();
        } else {
            dropdownStates.open();
        }
    };

    return (
        <css.state>
            <css.eventKindButton 
                onClick={handleToggle}
                disabled={!isSelected || disabled}
                eventKind={eventKind}
            >   
                <css.eventKindContent>
                    {eventKind ? (eventKind === 'mandatory' ? <MandatoryIcon /> : <OptionalIcon />) : null}
                    {getEventKindText(eventKind, t)}
                </css.eventKindContent>
            </css.eventKindButton>
            {dropdownStates.isOpen && <List
                list={eventKindOptions}
                showClass={dropdownStates.showClass}
                close={dropdownStates.close}
                width="100px"
                top={30}
            />}
        </css.state>
    );
}

